import { render, staticRenderFns } from "./guiji.vue?vue&type=template&id=07733be8"
import script from "./guiji.vue?vue&type=script&lang=ts"
export * from "./guiji.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports